import { Record } from 'immutable';
import _ from 'lodash';

const properties = {
  address: '',
  address2: '',
  city: '',
  area: '',
  postalCode: '',
  state: '',
  stateCode: '',
  country: '',
  countryCode: '',
  manualEntry: false,
  geo: undefined,
};

export default class LocationObject extends Record(properties, 'LocationObject') {
  public readonly address!: string;

  public readonly address2!: string;

  public readonly city!: string;

  public readonly area!: string;

  public readonly postalCode!: string;

  public readonly state!: string;

  public readonly stateCode!: string;

  public readonly country!: string;

  public readonly countryCode!: string;

  public readonly manualEntry!: boolean;

  public readonly geo!: {
    type: string;
    coordinates: number[];
  };

  constructor(values = {}) {
    super(_.pick(values, Object.keys(properties)));
  }

  public areaString(): string {
    return [
      this.area !== this.city && this.area,
      this.state ? this.city : `${this.postalCode} ${this.city}`.trim(),
      this.state && this.postalCode ? `${this.state} ${this.postalCode}` : this.state,
      this.country,
    ]
      .filter(Boolean)
      .join(', ');
  }

  public toString(skipCountry = false): string {
    return [
      this.address,
      this.address2,
      this.state ? this.city : `${this.city} ${this.postalCode}`.trim(),
      this.state && this.postalCode ? `${this.state} ${this.postalCode}` : this.state,
      !skipCountry && this.country,
    ]
      .filter(Boolean)
      .join(', ');
  }
}
